import React from "react";
import { formatDate } from "../../../../../utils/common-utils";
import "./ViewCp.css";


const ViewCp = ({ viewData }) => {
  return (
    <>
      <div className="card mt-4 position-relative">
        <span className="mt-2 mb-3 fw-bold badge_head text-center">Personal Information</span>
        <div className="row mb-1 pt-4 px-4">
          <div className="form-group col-sm-4 mb-0">
            <div className="row mobile-line-row">
              <div className="col-sm-6 label"><span>First Name</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.firstName}</div>
            </div>
          </div>
          <div className="form-group col-sm-4 mb-0">
            <div className="row mobile-line-row">
              <div className="col-sm-6 label"><span>Last Name</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.lastName}</div>
            </div>
          </div>
          <div className="form-group col-sm-4 mb-0">
            <div className="row mobile-line-row">
              <div className="col-sm-6 label"><span>Email</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.email}</div>
            </div>
          </div>
          <div className="form-group col-sm-4 mb-0">
            <div className="row mobile-line-row">
              <div className="col-sm-6 label"><span>Username</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.username}</div>
            </div>
          </div>
          <div className="form-group col-sm-4 mb-0">
            <div className="row mobile-line-row">
              <div className="col-sm-6 label"><span>Mobile Number</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.mobileNo}</div>
            </div>
          </div>
          <div className="form-group col-sm-4 mb-0">
            <div className="row mobile-line-row">
              <div className="col-sm-6 label"><span>Created Date</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">
                {formatDate(viewData?.createdDate)}
              </div>
            </div>
          </div>
        </div>

        {/* <div className="row mb-1 row_div px-4">
          
          <div className="form-group col-sm-4">
            <div className="row">
              <div className="col-sm-6 label"><span>Username</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.username}</div>
            </div>
          </div>
          <div className="form-group col-sm-4">
            <div className="row">
              <div className="col-sm-6 label"><span>Mobile Number</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.mobileNo}</div>
            </div>
          </div>
          <div className="form-group col-sm-4">
            <div className="row">
              <div className="col-sm-6 label"><span>Created Date</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">
                {formatDate(viewData?.createdDate)}
              </div>
            </div>
          </div>
        </div> */}

        {/* <div className="row mb-1 row_div px-4">
          <div className="col-sm-4">
            <div className="row">
              <div className="col-sm-6 label"><span>Country</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">
                {viewData?.cpCountryList?.[0]?.countryName}
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="row">
              <div className="col-sm-6 label"><span>Operator</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">
                {viewData?.cpCountryList?.[0]?.cpOperatorList?.[0]?.operatorName}
              </div>
            </div>
          </div>
        </div> */}
      </div>
      <div className="card mt-5 position-relative">
        <span className="mt-2 mb-3 fw-bold badge_head text-center">Company Information</span>

        <div className="row mb-1 px-4 pt-4">
          <div className="form-group col-sm-4 mb-0">
            <div className="row mobile-line-row">
              <div className="col-sm-6 label"><span>Company Name</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">
                {viewData?.cpDetailsList[0]?.companyName}
              </div>
            </div>
          </div>
          <div className="form-group col-sm-4 mb-0">
            <div className="row mobile-line-row">
              <div className="col-sm-6 label"><span>Company CIN</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">
                {viewData?.cpDetailsList[0]?.companyCin}
              </div>
            </div>
          </div>
          <div className="form-group col-sm-4 mb-0">
            <div className="row mobile-line-row">
              <div className="col-sm-6 label"><span>Street Address</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">
                {viewData?.cpDetailsList[0]?.streetAddress}
              </div>
            </div>
          </div>
          <div className="form-group col-sm-4 mb-0">
            <div className="row mobile-line-row">
              <div className="col-sm-6 label"><span>Pincode</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">
                {viewData?.cpDetailsList[0]?.zipcode}
              </div>
            </div>
          </div>
          <div className="form-group col-sm-4 mb-0">
            <div className="row mobile-line-row">
              <div className="col-sm-6 label"><span>City</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">
                {viewData?.cpDetailsList[0]?.city}
              </div>
            </div>
          </div>
          <div className="form-group col-sm-4 mb-0">
            <div className="row mobile-line-row">
              <div className="col-sm-6 label"><span>State</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">
                {viewData?.cpDetailsList[0]?.state}
              </div>
            </div>
          </div>
          <div className="form-group col-sm-4 mb-0">
            <div className="row mobile-line-row">
              <div className="col-sm-6 label"><span>Country</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">
                {viewData?.cpDetailsList[0]?.country}
              </div>
            </div>
          </div>
        </div>

        {/* <div className="row mb-1 row_div px-4">
         
          <div className="form-group col-sm-4">
            <div className="row">
              <div className="col-sm-6 label"><span>Pincode</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">
                {viewData?.cpDetailsList[0]?.zipcode}
              </div>
            </div>
          </div>
          <div className="form-group col-sm-4">
            <div className="row">
              <div className="col-sm-6 label"><span>City</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">
                {viewData?.cpDetailsList[0]?.city}
              </div>
            </div>
          </div>
          <div className="form-group col-sm-4">
            <div className="row">
              <div className="col-sm-6 label"><span>State</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">
                {viewData?.cpDetailsList[0]?.state}
              </div>
            </div>
          </div>
        </div> */}

        {/* <div className="row mb-1 row_div px-4">
          <div className="form-group col-sm-4">
            <div className="row">
              <div className="col-sm-6 label"><span>Country</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">
                {viewData?.cpDetailsList[0]?.country}
              </div>
            </div>
          </div>
        </div> */}
      </div>

      <div className="card mt-5 position-relative">
        <span className="mt-2 mb-3 fw-bold badge_head text-center">Business Contact</span>
        <div className="row mb-1 px-4 pt-4" >
          <div className="form-group col-sm-4 mb-0">
            <div className="row mobile-line-row">
              <div className="col-sm-6 label"><span>Contact Person</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">
                {viewData?.cpDetailsList[0]?.businessContactPerson}
              </div>
            </div>
          </div>
          <div className="form-group col-sm-4 mb-0">
            <div className="row mobile-line-row">
              <div className="col-sm-6 label"><span>Contact Email</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">
                {viewData?.cpDetailsList[0]?.businessContactEmail}
              </div>
            </div>
          </div>
          <div className="form-group col-sm-4 mb-0">
            <div className="row mobile-line-row">
              <div className="col-sm-6 label"><span>Contact Mobile</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">
                {viewData?.cpDetailsList[0]?.businessContactNumber}
              </div>
            </div>
          </div>
        </div>
      
        </div>

        <div className="card mt-5 position-relative">
        <span className="mt-2 mb-3 fw-bold badge_head text-center">Finance Contact</span>
        <div className="row mb-1 px-4 pt-4">
          <div className="form-group col-sm-4 mb-0">
            <div className="row mobile-line-row">
              <div className="col-sm-6 label"><span>Contact Person</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">
                {viewData?.cpDetailsList[0]?.financeContactPerson}
              </div>
            </div>
          </div>
          <div className="form-group col-sm-4 mb-0">
            <div className="row mobile-line-row">
              <div className="col-sm-6 label"><span>Contact Email</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">
                {viewData?.cpDetailsList[0]?.financeContactEmail}
              </div>
            </div>
          </div>
          <div className="form-group col-sm-4 mb-0">
            <div className="row mobile-line-row">
              <div className="col-sm-6 label"><span>Contact Mobile</span><span>:</span></div>
              <div className="col-sm-6 fw-bold text-wrap cont_div">
                {viewData?.cpDetailsList[0]?.financeContactNumber}
              </div>
            </div>
          </div>
        </div> 
       
      </div>
    </>
  );
};

export default ViewCp;
